/**
 * Dev session log types — persisted NDJSON + live tail.
 */
import { z } from "zod";
export const LogSourceSchema = z.enum(["server", "client"]);
export const LogLevelSchema = z.enum([
    "fatal",
    "error",
    "warn",
    "info",
    "debug",
    "trace",
]);
export const SessionLogEntrySchema = z
    .object({
    ts: z.string(),
    level: LogLevelSchema,
    msg: z.string(),
    source: LogSourceSchema,
    module: z.string().optional(),
    clientId: z.string().optional(),
    reqId: z.string().optional(),
    url: z.string().optional(),
})
    .passthrough();
export const ClientLogIngestBodySchema = z.object({
    clientId: z.string().min(1),
    entries: z.array(z.object({
        ts: z.string(),
        level: LogLevelSchema,
        msg: z.string(),
        module: z.string().optional(),
        url: z.string().optional(),
    }).passthrough()),
});
//# sourceMappingURL=logs.js.map